import { ClipSearchService } from '@src/services/clipSearch/ClipSearchService';
import { useMemo } from 'react';

import type { IVideoCreatorStore } from '@src/stores/IVideoCreatorStore';
import type { RootStore } from '@src/stores-v2/RootStore';

/**
 * DI seam for `ClipSearchService`, mirroring `useCommentService`.
 *
 * The instance is memoized on its deps so the identity is stable across
 * renders — a fresh service every render would re-fire any effect that lists
 * it (the hook-mock trap documented in CLAUDE.md → Testing).
 */
export function useClipSearchService(
  videoCreator: IVideoCreatorStore,
  rootStore: RootStore,
): ClipSearchService {
  return useMemo(
    () => new ClipSearchService({ videoCreator, rootStore }),
    [videoCreator, rootStore],
  );
}
